import { render, staticRenderFns } from "./selaPromotionDetail.vue?vue&type=template&id=804abe3c"
import script from "./selaPromotionDetail.vue?vue&type=script&lang=js"
export * from "./selaPromotionDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports